<template>
  <div class="upload">
    <view class="propbox" v-if="show">
      用于咨询商品信息或者申请售后服务时，打开存储/相册/相机发送指定信息。
    </view>
    <!-- 支持视频文件上传，添加了常见视频格式 -->
    <input type="file" @change="handlePreview($event)" accept="*" id="files" v-if="canUpload"/>
    <div id="files" @click="requQx" v-else></div>
  </div>
</template>

<script setup>
  import axios from 'axios';
  import  { ref} from 'vue';
  import { baseURL  } from '@/config'
  import { getQueryString} from '@/assets/js/index'
  import { useSocket} from "@/stores/index";
  import { useWork } from "@/stores/work";
  import { sendType} from '@/assets/js/index'
	import { showLoadingToast, closeToast,showToast,showConfirmDialog } from 'vant';
  const canUpload = ref(false);
  const show=ref(false);
  const decode=ref({});
  const store = useSocket();
  const showPermissionGuide = () => {
    showConfirmDialog({
      title: '权限提示',
      message: '需要相机/相册权限才能上传文件，是否前往设置？',
    }).then(() => {
      try {
        const Intent = plus.android.importClass('android.content.Intent')
        const Settings = plus.android.importClass('android.provider.Settings')
        const Uri = plus.android.importClass('android.net.Uri')
        const mainActivity = plus.android.runtimeMainActivity()

        // 关键修改：使用标准的 package URI 格式
        const intent = new Intent(Settings.ACTION_APPLICATION_DETAILS_SETTINGS)
        intent.setData(Uri.parse(`package:${mainActivity.getPackageName()}`)) // 改为 parse 方法构造 URI
        intent.addFlags(0x10000000) // 可选：部分机型可能需要此标志，测试后保留或移除

        mainActivity.startActivity(intent)
      } catch (error) {
        console.error('设置跳转失败:', error)
      }
      show.value = false;
    }).catch(() => {
      // 用户取消操作
      show.value = false;
      console.log('用户取消了权限设置')
    });
  };
  const requQx = () => {
    if(window.plus && window.plus.os.name === 'Android') {
      if(!canUpload.value) {
         show.value = true;
      }
      plus.android.requestPermissions(['android.permission.CAMERA','android.permission.READ_EXTERNAL_STORAGE'], function(e) {  
        decode.value= e;
        if(decode.value.deniedAlways && decode.value.deniedAlways.length > 0) {
          showPermissionGuide();
          return false;
        }
        if (e.deniedAlways.length > 0) {  
            console.log('Always Denied!!! ' + e.deniedAlways.toString());  
        }  
        if (e.deniedPresent.length > 0) {  
            console.log('Present Denied!!! ' + e.deniedPresent.toString());  
        }  
        if (e.granted.length ==2) {  
            canUpload.value = true;
            document.getElementById('files').click();
            console.log('Granted!!! ' + e.granted.toString());  
        }  
        show.value = false;
      }, function(e) {  
          console.log('Request Permissions error:' + JSON.stringify(e));  
      });
    } else {
      // show.value = true;
      canUpload.value = true;
      document.getElementById('files').click();
    }
   
  };
  const handlePreview = async(event) => {
    useWork().reconnect()
    const files = event.target.files[0];
    const file = files;
    const maxSize = 10 * 1024 * 1024; // 10MB 图片最大限制
    const allowedTypes = ['image/jpeg', 'image/png', 'image/gif','image/jpg','image/bmp','video/mp4','video/quicktime','video/mov']; // 允许的图片类型
    const videoMaxSize = 100 * 1024 * 1024; // 100MB 视频最大限制
    // 先做基础校验，避免无谓的视频元数据解析
    if (!allowedTypes.includes(file.type)) {
      showToast('请选择有效的图片文件');
      return;
    }
    if (file.size > maxSize && !file.type.includes('video')) {
      showToast('图片文件大小不能超过 10MB');
      return;
    }
    if (file.type.includes('video') && file.size> videoMaxSize) {
      showToast('视频文件大小不能超过 100MB');
      return;
    }
    // 第一时间弹 loading，避免 iOS 大视频解析元数据期间无反馈
    showLoadingToast({
      message: file.type.includes('video') ? '处理中...' : '上传中...',
      duration: 0,
    });
    if (file.type.includes('video')) {
      // 处理视频上传
      const isVideoValid = await checkVideoValidity(file);
      if (!isVideoValid) {
        closeToast();
        return;
      }
      // 校验通过，切换到上传中
      showLoadingToast({
        message: '上传中...',
        duration: 0,
      });
    }
    
    //useWork().setUpLoading(true)

    const form = new FormData();
    form.append('file', file);
    try {
      const response = await axios({
        method: 'post',
        url: baseURL + "app-api/infra/file/get_presigned_url_for_oss_upload",
        data: {
          name:file.name
        },
        headers: {
          'Authorization': 'Bearer ' + useWork().auth.token,
          'wxappId': getQueryString('wxappId')
        }
      });
      if(response.data.code==0){
        const ndata=response.data.data
        fetch(ndata.uploadUrl, {
          method: "PUT",
          headers: new Headers({
            "Content-Type":file.type,
          }),
          body: file,
       }).then((res) => {
         
          if (!res.ok) {
            closeToast();
            useWork().setUpLoading(false)
            throw new Error("文件上传到OSS失败");
          }
          else{
            let formData = {
              content: JSON.stringify({
                'imgUrl':ndata.url
              }),
              type: sendType.IMG
            };
              const fileInput = document.getElementById('files');
              if (fileInput) {
                  fileInput.value = '';
              }
              store.sendMess(formData);
              closeToast();
              useWork().setUpLoading(false)
            }
          }); 
        }
    } catch (error) {
      showToast('上传过程中出现错误');
      useWork().setUpLoading(false)
      closeToast();
    }finally{
      document.getElementById('files').value = ''; 
  
    }
  
  };
  const checkVideoValidity = (file) => {
    return new Promise((resolve) => {
      const video = document.createElement('video');
      video.preload = 'metadata';
      let settled = false;
      const url = URL.createObjectURL(file);
      const cleanup = () => {
        URL.revokeObjectURL(url);
        video.removeAttribute('src');
        video.load();
      };
      video.onloadedmetadata = () => {
        if (settled) return;
        settled = true;
        const duration = video.duration;
        cleanup();
        if (duration > 600) { // 10 分钟（600 秒）
          showToast('视频时长不能超过 10 分钟');
          resolve(false);
        } else {
          resolve(true);
        }
      };
      video.onerror = () => {
        if (settled) return;
        settled = true;
        cleanup();
        showToast('无法获取视频时长信息');
        resolve(false);
      };
      // iOS 下 onloadedmetadata 偶发不触发，加超时保护避免卡死
      setTimeout(() => {
        if (settled) return;
        settled = true;
        cleanup();
        console.warn('checkVideoValidity 超时，跳过时长校验');
        resolve(true);
      }, 5000);
      video.src = url;
    });
  };
</script>

<style lang="scss" scoped>
  .upload {
    #files {
      position: absolute;
      width: 100%;
      height: 100%;
      opacity: 0;
      left: 0;
      top: 0;
    }
  }
   .propbox {
      position: fixed;
      top: 6%;
      left: 10%;
      z-index: 99999999;
      box-sizing: border-box;
      width: 80%;
      padding: 10px;
      font-size: 14px;
      color: #333;
      background: #dae1e8;
      border-radius: 10px;
    }
</style>